import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Flex } from 'reflexbox'
import { 
    aeResourceLevelOptionsSelector, 
    projectHealthOptionsSelector, 
} from '../selectors'
import Switch from 'react-toolbox/lib/switch'
import ColorDropdown from 'components/form/colorDropdown'
import Dropdown from 'components/form/dropdown'
import Input from 'components/form/input'
import SubmitButton from './SubmitButton'
import styles from './styles.scss'

const mapStateToProps = state => {
    return {
        aeResourceLevelOptions: aeResourceLevelOptionsSelector(state),
        projectHealthOptions: projectHealthOptionsSelector(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

class ProjectExecutionTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ae_resource_level: {
                enabled: false,
                value: ""
            },
            project_health: {
                enabled: false,
                value: ""
            },
            ae_notes: {
                enabled: false,
                value: ""
            },
            project_waiver_details:{
                enabled: false,
                value: ""
            }
        }
    }
    handleSwitchSelect = (key) => {
        let current = this.state[key]
        current.enabled = !current.enabled
        this.setState({
            [key]: current
        })
    }
    updateAeResourceLevel = (index) => {
        let current = this.state.ae_resource_level
        current.value = index
        this.setState({ ae_resource_level: current })
    }
    updateProjectExecution = (index) => {
        let current = this.state.project_health
        current.value = index
        this.setState({ project_health: current})
    }
    updateAeNotes = (note) => {
        let current = this.state.ae_notes
        current.value = note
        this.setState({ ae_notes: current})
    }
    updateProjectWaiver = (text) => {
        let current = this.state.project_waiver_details
        current.value = text
        this.setState({ project_waiver_details: current })
    }

    cancelState = () => this.setState({
        ae_resource_level: {
            enabled: false,
            value: ""
        },
        project_health: {
            enabled: false,
            value: ""
        },
        ae_notes: {
            enabled: false,
            value: ""
        },
        project_waiver_details:{
            enabled: false,
            value: ""
        }
    })
    render(){
        const {
            aeResourceLevelOptions,
            projectHealthOptions,
            numberOfProjects
        } = this.props
        
        let enabledFields = {}
        Object.entries(this.state).forEach((field) => {
            if(field[1].enabled) {
                enabledFields = {
                    ...enabledFields,
                    [field[0]]: field[1].value
                }
            } else {
                enabledFields = {
                    ...enabledFields,
                    [field[0]]: ""
                }
            }
        })
        return(
            <div>
                <SubmitButton numberOfProjects={numberOfProjects} cancelState={this.cancelState} formDetails={enabledFields} formType="projectExecution" />
            <div styleName="projectExecutionForm">
                <Flex styleName='aeResourceContainer'  >
                    <Switch 
                        styleName="projectExecutionSwitch"
                        checked={this.state.ae_resource_level.enabled}
                        onChange={() => this.handleSwitchSelect('ae_resource_level')}
                    />
                    <div styleName='aeResourceDropdown'>
                    <Dropdown 
                        class={styles.help}
                        title='AE Resource Level'
                        disabled={!this.state.ae_resource_level.enabled}
                        source={aeResourceLevelOptions}
                        value={this.state.ae_resource_level.value}
                        onChange={this.updateAeResourceLevel}
                        />
                    </div>
                </Flex>
                <Flex styleName="projectHealthContainer">
                    <Switch 
                        styleName="projectExecutionSwitch"
                        checked={this.state.project_health.enabled}
                        onChange={() => this.handleSwitchSelect('project_health')}
                    />

                    <div styleName='projectHealthDropdown'>
                        <ColorDropdown 
                            title='Project Health'
                            disabled={!this.state.project_health.enabled}
                            source={projectHealthOptions}
                            value={this.state.project_health.value}
                            onChange={this.updateProjectExecution}
                        />
                    </div>
                </Flex>
                <Flex styleName='aeNotesContainer'>
                    <Switch 
                        styleName="projectExecutionSwitch"
                        checked={this.state.ae_notes.enabled}
                        onChange={() => this.handleSwitchSelect('ae_notes')}
                    />
                    <div styleName='aeNotesInput'>
                        <Input
                            styleName='projectExecutionInput'
                            title='AE Notes'
                            type='text'
                            disabled={!this.state.ae_notes.enabled}
                            value={this.state.ae_notes.value}
                            onChange={this.updateAeNotes}
                        />
                    </div>

                </Flex>
                <Flex styleName='projectWaiverContainer'>
                    <Switch 
                        styleName="projectExecutionSwitch"
                        checked={this.state.project_waiver_details.enabled}
                        onChange={() => this.handleSwitchSelect('project_waiver_details')}
                    />

                    <div styleName='projectWaiverInput'>
                        <Input
                            title='Project Waiver Details'
                            type='text'
                            disabled={!this.state.project_waiver_details.enabled}
                            value={this.state.project_waiver_details.value}
                            onChange={this.updateProjectWaiver}
                        />
                    </div>
                </Flex>
            </div>
            </div>
        )
    }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(ProjectExecutionTab)